import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import CreateSourceModal from "./CreateSourceModal.layout";

const mapStateToProps = (state: any) => ({
    trackers: state.allTrackersState.trackers,
    singleTracker: state.allTrackersState.singleTracker,
    language: state.languagesState.languages,
    sourcesTypes: state.allSourcesTypesState.sources,
    sourcesTypesStatus: state.allSourcesTypesState.status,
});
const mapDispatchToProps = () => ({});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(CreateSourceModal);
